"use client";

import { motion } from "framer-motion";
import type { Locale } from "@/config/i18n";
import { CHAUFFEUR_SLUG_UI } from "./chauffeurSlugUi";
import { tr } from "@/config/localeText";

type ServiceCommitmentSectionProps = {
  badges: string[];
  locale?: Locale;
};

export default function ServiceCommitmentSection({
  badges,
  locale = "fr",
}: ServiceCommitmentSectionProps): JSX.Element {
  const ui = tr(CHAUFFEUR_SLUG_UI, locale);
  const metrics = badges.length ? badges : ui.commitmentDefaultBadges;

  return (
    <section className="bg-primary py-12 text-black">
      <div className="mx-auto max-w-[90rem] px-6 md:px-8">
        <motion.p
          initial={false}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-10%" }}
          transition={{ duration: 0.4 }}
          className="mb-2 text-xs uppercase tracking-[0.2em] text-black/70"
        >
          {ui.commitmentEyebrow}
        </motion.p>
        <motion.h2
          initial={false}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-10%" }}
          transition={{ duration: 0.45 }}
          className="font-space-age text-xl tracking-[0.2em]"
        >
          {ui.commitmentTitle}
        </motion.h2>
        <motion.p
          initial={false}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-10%" }}
          transition={{ duration: 0.45, delay: 0.05 }}
          className="mt-3 max-w-3xl text-sm text-black/80"
        >
          {ui.commitmentText}
        </motion.p>

        <div className="mt-5 grid gap-3 md:grid-cols-3">
          {metrics.map((badge, index) => (
            <motion.article
              key={badge}
              initial={false}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-10%" }}
              transition={{ duration: 0.35, delay: index * 0.05 }}
              whileHover={{ y: -2 }}
              className="rounded-xl border border-white/20 bg-black px-4 py-3 text-sm font-medium text-white"
            >
              {badge}
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
